import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Hospitals} from "./hospitals";


const routes: Routes = [
  {
    path: 'tutors',
    component: Hospitals,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HospitalsRoutingModule {}
